var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"cols":"8"}},[_vm._t("date-term-content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }